import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import SweetAlert from 'react-bootstrap-sweetalert';

/* Function */
import ObjGeneral from '../function/';
import constants from '../function/constants';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as accountUserActions from '../../actions/account_user/index';

/* Components */
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index.jsx';
import Title from '../../components/account_user/title';
import Header from '../../components/account_user/header';
import Buttons from '../../components/account_user/buttons';
import Table from '../../components/account_user/table';
import ModalCreate from '../../components/account_user/modalCreate';
import ModalEdit from '../../components/account_user/modalEdit';
import ModalPass from '../../components/account_user/modalPass';
import ModalDelete from '../../components/account_user/modalDelete';
import ModalActive from '../../components/account_user/modalActive';
import ModalDownload from '../../components/account_user/modalDownload';
import ModalUpdate from '../../components/account_user/modalUpdate';
import ModalDownloadAssociateUsers from '../../components/account_user/modalDownloadAssociateUsers.jsx';
import ModalUpdateAssociateUsers from '../../components/account_user/modalUpdateAssociateUsers.jsx';

class AccountUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pag: 1,
      sort: true,
      modal: false,
      modalEdit: false,
      modalPass: false,
      modalDelete: false,
      modalActive: false,
      user: { a: false, b: false, c: true },
      tags: [],
      rol: null,
      arrTags: [],
      config: {
        rootes: false,
        id: '',
        name: '',
        mail: '',
        tags: [],
        roles: []
      },
      multipleTagsAllow: false,
      multipleTagsAllowChangeEvent: null,
      showConfirmChangeMultipleTagsState: false,
      modalDownload: false,
      modalDownloadAssociateUsers: false,
      modalUpdate: false,
      modalUpdateAssociateUsers: false
    };

    this.permissionsRef = {};
    this.listMediaPermissions = ['MediaCognusFaceVerificationAccess', 'MediaDownloadAccess', 'MediaListenAudioAccess', 'MediaDmsAccess', 'MediaDashcamAccess', "MediaUnidentifiedDriverAccess"];
    this.listPermissionAssociatedWithMedia = ['ManageFullAccess', 'ManageReadAccess'];
    this.listEntitiesPermissions = ['AccountManagerCrudAccessDrivers', 'AccountManagerCrudAccessGeozones', 'AccountManagerCrudAccessTags', 'AccountManagerCrudAccessVehicles'];
    this.permissionAccountManagerCrudAccess = 'AccountManagerCrudAccess';
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('user');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('account')) {
          await this.props.actions.fetchAccountUserRollApi({});
          await this.props.actions.fetchOptionsToCreateUser();
          await this.props.actions.fetchAccountUserCountApi({ user: this.state.user });
          await this.props.actions.fetchAccountUserApi({
            pag: this.state.pag,
            user: this.state.user
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  componentWillUnmount() {
    this.props.actions.resetAccountUser();
  }

  handleSearch = async event => {
    if (!this.props.loading) {
      const value = event.target.value;
      this.setState({ pag: 1 });
      await this.props.actions.fetchAccountUserNoLoadingApi({
        rol: this.state.rol,
        tags: this.state.arrTags,
        user: this.state.user,
        sort: this.state.sort,
        filter: value,
        pag: 1,
        concat: false
      });
      await this.props.actions.fetchAccountUserCountApi({
        rol: this.state.rol,
        tags: this.state.arrTags,
        user: this.state.user,
        filter: value
      });
    }
  };

  handleScroll = async event => {
    if (
      this.state.pag < this.props.count.pages &&
      this.state.modalEdit == false &&
      this.state.modalPass == false &&
      this.state.modal == false
    ) {
      const scroll = event.target.scrollTop;
      const max = event.target.scrollHeight - event.target.offsetHeight;
      const value = document.getElementById('search').value;
      if (scroll >= max) {
        this.setState({ pag: this.state.pag + 1 });
        const pag = this.state.pag + 1;
        await this.props.actions.fetchAccountUserNoLoadingApi({
          rol: this.state.rol,
          tags: this.state.arrTags,
          user: this.state.user,
          filter: value,
          pag: pag,
          concat: true,
          sort: this.state.sort
        });
      }
    }
  };

  handleSort = async event => {
    this.setState({ pag: 1 });
    const value = document.getElementById('search').value;
    const sort = this.state.sort ? false : true;
    await this.props.actions.fetchAccountUserNoLoadingApi({
      rol: this.state.rol,
      tags: this.state.arrTags,
      user: this.state.user,
      filter: value,
      sort: sort,
      pag: 1,
      concat: false
    });
    this.setState({ sort: this.state.sort ? false : true });
  };

  handleSelect = async event => {
    const element = event.currentTarget;
    const parent = element.dataset.parent;
    const id = element.id;
    const arr = document.querySelectorAll(`[id^='${parent}'] > li `);
    const arrArray = Array.from(arr);
    if (!element.classList.contains('block')) {
      element.classList.toggle('select');
      if(!this.state.multipleTagsAllow || element.dataset.value=="*") {
        arrArray.forEach(item => {
          if (id != item.id) {
            item.classList.add('block');
            item.classList.remove('select');
          }
        });
        if (!element.classList.contains('select')) {
          arrArray.forEach(item => {
            item.classList.remove('block');
          });
        }
      }
    }
  };

  checkTagsState = event => {
    const element = event == null ? this.state.multipleTagsAllowChangeEvent : event.currentTarget;
    const parent = element.dataset.roleparent;
    const arr = document.querySelectorAll(`[id^='${parent}'] > li `);
    const arrArray = Array.from(arr);
    let newMultipleTagsAllow = true;
    let empty = true;

    // change selection state
    element.classList.toggle('select');

    // calculate current state
    arrArray.forEach(item => {
      if (item.classList.contains('select')) {
        empty = false;
        if (!this.isMultipleTagsAllow(item.dataset.value)) {
          newMultipleTagsAllow = false;
        }
      }
    });
    if(empty) {
      newMultipleTagsAllow = false;
    }
    element.classList.toggle('select');

    return newMultipleTagsAllow;
  };

  /**
   * check what actions you must perform when selecting certain permissions
   * @param {Object} event event associated with the component that calls it
   */
  handlePermissionSelection = (event) => {
    let element = event.currentTarget;
    const permission = element.dataset.value;

    // get element from list of references
    element = this.permissionsRef[permission];

    // if any permissions associated with media are checked / unchecked, execute the following method to set permissions related to them
    if (this.listMediaPermissions.includes(permission)) {
      this.setPermissionsAssociatedWithMedia(element);
    }

    // if the permissions associated with the entity settings are checked/unchecked, run the following method to set the permissions related to them
    if (this.listEntitiesPermissions.includes(permission) || this.permissionAccountManagerCrudAccess === permission) {
      this.setPermissionsAssociatedWithEntities(element, permission);
    }

    // continue with the flow of activation / deactivation of multi-selection permissions of tags
    this.handleSelectCheckPrecheckStateChange(event);
  }

  /**
   * sets the permission values ​​associated with media permissions when they are selected
   * @param {Object} element check element of the html that triggers this action
   */
  setPermissionsAssociatedWithMedia = (element) => {
    // change selection state
    if (element) {
      element.classList.toggle('select');
    }

    // loop through all media permissions, and if at least one is selected, the associated permissions should be checked
    let totalMediaPermissionsSelected = 0;
    this.listMediaPermissions.forEach(permission => {
      const elemCheck = this.permissionsRef[permission];
      if (elemCheck) {
        const checked = elemCheck.classList.contains('select');
        if (checked) {
          totalMediaPermissionsSelected++;
        }
      }
    });

    // if there is at least one media permission checked, then check all permissions associated with them
    // otherwise leave them enabled
    if (totalMediaPermissionsSelected > 0) {
      this.listPermissionAssociatedWithMedia.forEach(permission => {
        const elemCheck = this.permissionsRef[permission];
        if (elemCheck) {
          elemCheck.classList.remove('enabled-item');
          elemCheck.classList.add('select', 'disabled-item', 'no-click');
        }
      });
    } else {
      this.listPermissionAssociatedWithMedia.forEach(permission => {
        const elemCheck = this.permissionsRef[permission];
        if (elemCheck) {
          elemCheck.classList.remove('disabled-item', 'no-click');
          elemCheck.classList.add('enabled-item');
        }
      });
    }

    // change selection state because inside the handleSelectCheckPrecheckStateChange() event is used again
    if (element) {
      element.classList.toggle('select');
    }
  }

  /**
   * sets the permission values associated with entity configuration permissions when they are selected
   * @param {Object} element check element of the html that triggers this action
   * @param {String} permission permission name
   */
  setPermissionsAssociatedWithEntities = (element, permission) => {
    // change selection state
    if (element) {
      element.classList.toggle('select');
    }

    // if permission is "Configure entities" (AccountManagerCrudAccess), select all related permissions
    if (permission === this.permissionAccountManagerCrudAccess) {
      this.setCheckAllEntityPermissions();
    } else {
      this.setCheckParentPermission();
    }

    // change selection state because inside the handleSelectCheckPrecheckStateChange() event is used again
    if (element) {
      element.classList.toggle('select');
    }
  }

  /**
   * check or uncheck all permissions related to entity creation, depending on the parent permission
   * @param {String} parentPermission parent permission name
   */
  setCheckAllEntityPermissions = () => {
    const parentCheck = this.permissionsRef[this.permissionAccountManagerCrudAccess];
    const parentChecked = parentCheck.classList.contains('select');

    // scroll through the related permissions to check or uncheck it
    this.listEntitiesPermissions.forEach(entityPermission => {
      const elemCheck = this.permissionsRef[entityPermission];
      if (elemCheck) {
        if (parentChecked) {
          elemCheck.classList.add('select');
        } else {
          elemCheck.classList.remove('select');
        }
      }
    });
  }

  /**
   * check or uncheck the parent permission, depending on whether the permissions associated with entity creation are checked or not
   */
  setCheckParentPermission = () => {
    const parentCheck = this.permissionsRef[this.permissionAccountManagerCrudAccess];
    let totalEntitiesPermissionsSelected = 0;

    // walk through the permissions related to entity creation and check if they are checked
    this.listEntitiesPermissions.forEach(permission => {
      const elemCheck = this.permissionsRef[permission];
      if (elemCheck) {
        const checked = elemCheck.classList.contains('select');
        if (checked) {
          totalEntitiesPermissionsSelected++;
        }
      }
    });

    // if the total of checked permissions is equal to the total of related permissions, the parent permission will be selected. Otherwise it is unchecked.
    if (parentCheck) {
      if (totalEntitiesPermissionsSelected === this.listEntitiesPermissions.length) {
        parentCheck.classList.add('select');
      } else {
        parentCheck.classList.remove('select');
      }
    }
  }

  handleSelectCheckPrecheckStateChange = async event => {
    let newMultipleTagsAllow = this.checkTagsState(event);
    const element = event.currentTarget;
    const parent = element.dataset.roleparent;
    const listsName = parent == "roleup" ? "listup" : "list";
    const arr = document.querySelectorAll(`[data-${listsName}] > li.select `);
    const arrArray = Array.from(arr);

    if(newMultipleTagsAllow != this.state.multipleTagsAllow && !newMultipleTagsAllow
      && arrArray.length>0) {
      this.state.multipleTagsAllowChangeEvent = event.currentTarget;
      this.setState({
        showConfirmChangeMultipleTagsState: true
      });
    }
    else {
      this.handleSelectCheck(event);
    }
  };

  handleSelectCheck = async event => {
    const element = event == null ? this.state.multipleTagsAllowChangeEvent : event.currentTarget;
    const parent = element.dataset.roleparent;
    const listsName = parent == "roleup" ? "listup" : "list";
    let newMultipleTagsAllow = this.checkTagsState(event);

    // change selection state
    element.classList.toggle('select');

    // if status is different from the previous change it
    // if it changes to false clear the tags
    // if set to true only unlock less those with all selected
    if(newMultipleTagsAllow != this.state.multipleTagsAllow) {
      this.setState({
        multipleTagsAllow: newMultipleTagsAllow
      });

      const arrList = document.querySelectorAll(`[data-${listsName}]`);
      const arrListArray = Array.from(arrList);
      arrListArray.forEach((item,i) => {
        const arrTags = document.querySelectorAll(`[data-parent="${listsName}-${i}"]`);
        const arrTagsArray = Array.from(arrTags);
        let isSelectAll = false;
        arrTagsArray.forEach(tag => {
          if(newMultipleTagsAllow == false) {
            tag.classList.remove('select');
            tag.classList.remove('block');
          }
          else if(tag.classList.contains('select') && tag.dataset.value=="*") {
            isSelectAll = true
          }
          else if (isSelectAll == false) {
            tag.classList.remove('block');
          }
        });
      });
    }
  };

  handleUserFilter = async event => {
    const select = event.target.dataset.select;
    document.getElementById('select-filter').innerHTML = `<span>Mostrar:</span><div>${event.target.innerHTML}</div>`;
    const value = document.getElementById('search').value;
    let obj = {};
    if (select == 'a') {
      this.setState({ user: { a: true, b: false, c: false } });
      obj = { a: true, b: false, c: false };
    } else if (select == 'b') {
      this.setState({ user: { a: false, b: true, c: false } });
      obj = { a: false, b: true, c: false };
    } else if (select == 'c') {
      this.setState({ user: { a: false, b: false, c: true } });
      obj = { a: false, b: false, c: true };
    }
    await this.props.actions.fetchAccountUserNoLoadingApi({
      rol: this.state.rol,
      tags: this.state.arrTags,
      filter: value,
      sort: this.state.sort,
      pag: 1,
      concat: false,
      user: obj
    });
    await this.props.actions.fetchAccountUserCountApi({
      rol: this.state.rol,
      tags: this.state.arrTags,
      filter: value,
      user: obj
    });
    this.setState({ pag: 1 });
  };

  handleModal = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modal ? false : true;
      this.setState({ modal: reset, multipleTagsAllow: false });
      if (!reset) {
        this.props.actions.resetModalUser();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1, user: { a: false, b: false, c: true }, arrTags: [], rol: null });

          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
      }
    }
  };

  handleModalEdit = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalEdit ? false : true;
      this.setState({ modalEdit: reset });
      if (!reset) {
        this.setState({
          config: {
            rootes: false,
            id: '',
            name: '',
            mail: '',
            tags: [],
            roles: []
          }
        });
        this.props.actions.resetModalUser();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1, user: { a: false, b: false, c: true }, arrTags: [], rol: null });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        const arrRoles = [];

        let multipleTagsAllowInitialState = obj.roles.length == 0 ? false : true;
        obj.roles.forEach(item => {
          arrRoles.push(item);
          if (!this.isMultipleTagsAllow(item)) {
            multipleTagsAllowInitialState = false;
          }
        });
        this.setState({
          config: {
            rootes: obj.root,
            id: obj.id,
            name: obj.name,
            mail: obj.userName,
            tags: obj.filterTags,
            roles: arrRoles
          },
          multipleTagsAllow: multipleTagsAllowInitialState
        });

        this.props.actions.fetchUserToEdit({id: obj.id});
      }
    }
  };

  handleModalPass = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalPass ? false : true;
      this.setState({ modalPass: reset });
      if (!reset) {
        this.props.actions.resetModalUser();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1, user: { a: false, b: false, c: true }, arrTags: [], rol: null });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        const arrTags = [];
        const arrRoles = [];

        obj.filterTags.forEach(item => {
          arrTags.push(item.tag);
        });
        obj.roles.forEach(item => {
          arrRoles.push(item);
        });

        this.setState({
          config: {
            rootes: obj.root,
            id: obj.id,
            name: obj.name,
            mail: obj.userName,
            tags: arrTags,
            roles: arrRoles
          }
        });
      }
    }
  };

  handleModalDelete = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDelete ? false : true;
      this.setState({ modalDelete: reset });
      if (!reset) {
        this.props.actions.resetModalUser();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1, user: { a: false, b: false, c: true }, arrTags: [], rol: null });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            rootes: obj.root,
            id: obj.id,
            name: obj.name,
            mail: obj.userName,
            roles: [],
            tags: []
          }
        });
      }
    }
  };

  handleModalActive = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalActive ? false : true;
      this.setState({ modalActive: reset });
      if (!reset) {
        this.props.actions.resetModalUser();
        if (this.props.statusSave == 200) {
          this.setState({ pag: 1, user: { a: false, b: false, c: true }, arrTags: [], rol: null });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
      } else {
        const obj = JSON.parse(e.target.dataset.datos);
        this.setState({
          config: {
            rootes: obj.root,
            id: obj.id,
            name: obj.name,
            mail: obj.userName,
            roles: [],
            tags: []
          }
        });
      }
    }
  };

  handleChange = e => {
    let config = { ...this.state.config };
    if (e.target.type === 'checkbox') {
      config[e.target.dataset.update] = e.target.checked;
    } else {
      config[e.target.dataset.update] = e.target.value;
    }
    this.setState({
      config
    });
  };

  handleTagsFilter = async event => {
    const select = event.target.dataset.select;
    const parent = event.target.dataset.parent;
    const category = event.target.dataset.category;
    const value = document.getElementById('search').value;
    const tags = this.state.tags;

    const index = this.state.tags
      .map(function(e) {
        return e.category;
      })
      .indexOf(category);
    const arr = [];

    document.getElementById(parent).innerHTML = `
      <span class="dropdown-title">${strings.filter[event.target.dataset.category]}:</span>
      <div class="dropdown-subtitle">${event.target.innerHTML}</div>
    `;

    if (index >= 0) {
      if (select != '*') {
        tags.push({ name: select, category: category });
      }
      tags.splice(index, 1);
    } else {
      if (select != '*') {
        tags.push({ name: select, category: category });
      }
    }

    tags.forEach(item => {
      arr.push(item.name);
    });

    this.setState({ tags: tags });
    this.setState({ arrTags: arr });

    await this.props.actions.fetchAccountUserNoLoadingApi({
      rol: this.state.rol,
      filter: value,
      sort: this.state.sort,
      pag: 1,
      concat: false,
      user: this.state.user,
      tags: arr
    });
    await this.props.actions.fetchAccountUserCountApi({
      rol: this.state.rol,
      filter: value,
      user: this.state.user,
      tags: arr
    });
  };

  handleRolesFilter = async event => {
    const select = event.target.dataset.select;
    const parent = event.target.dataset.parent;
    const value = document.getElementById('search').value;

    document.getElementById(parent).innerHTML = `
      <span class="dropdown-title">${event.target.dataset.name}:</span>
      <div class="dropdown-subtitle">${event.target.innerHTML}</div>
    `;

    const rol = select == '*' ? null : select;
    this.setState({ rol: rol });
    await this.props.actions.fetchAccountUserNoLoadingApi({
      rol: rol,
      filter: value,
      sort: this.state.sort,
      pag: 1,
      concat: false,
      user: this.state.user,
      tags: this.state.arrTags
    });
    await this.props.actions.fetchAccountUserCountApi({
      rol: rol,
      filter: value,
      user: this.state.user,
      tags: this.state.arrTags
    });
  };

  handleAdmin = event => {
    let arr = [];
    let allRealDivsArray = [];
    if (event.target.dataset.update) {
      arr = document.querySelectorAll('[data-rolup]');
      allRealDivsArray = Array.from(arr);
    } else {
      arr = document.querySelectorAll('[data-rol]');
      allRealDivsArray = Array.from(arr);
    }
    if (event.target.checked) {
      allRealDivsArray.forEach(item => {
        item.classList.add('block');
        item.classList.add('select');
      });
    } else {
      allRealDivsArray.forEach(item => {
        item.classList.remove('block');
        item.classList.remove('select');
      });
    }

    // sets the permissions associated with media permissions
    this.setPermissionsAssociatedWithMedia(null);
  };

  handleSubmit = async event => {
    const countList = document.querySelectorAll('[data-list]');
    const countListArray = Array.from(countList);
    const rolesArr = document.querySelectorAll('[data-rol]');
    const rolesArray = Array.from(rolesArr);
    const mail = document.getElementById('mail').value;
    const name = document.getElementById('name').value;
    const pass = document.getElementById('pass').value;
    const roote = document.getElementById('roote')
      ? document.getElementById('roote').checked
      : false;

    let i, e;
    let countParents;
    let tags = [];
    let roles = [];
    let objTags;
    for (i = 0; i <= countListArray.length - 1; i++) {
      countParents = document.querySelectorAll(`[data-parent="list-${i}"]`);
      const countParentsArray = Array.from(countParents);
      for (e = 0; e <= countParentsArray.length - 1; e++) {
        if (document.getElementById(`list-${i}-${e}`).classList.contains('select')) {
          objTags = {};
          objTags.tag = document.getElementById(`list-${i}-${e}`).dataset.value;
          objTags.tagCategory = document.getElementById(`list-${i}-${e}`).dataset.category;
          tags.push(objTags);
        }
      }
    }

    rolesArray.forEach(item => {
      if (item.classList.contains('select')) {
        roles.push(item.dataset.value);
      }
    });

    const obj = {
      userName: mail,
      name: name,
      filterTags: tags,
      roles: roles,
      root: roote,
      password: pass
    };

    const arr = [obj];
    await this.props.actions.handleUser({ user: arr });
  };

  handleSubmitEdit = async event => {
    const countList = document.querySelectorAll('[data-listup]');
    const countListArray = Array.from(countList);
    const rolesArr = document.querySelectorAll('[data-rolup]');
    const rolesArray = Array.from(rolesArr);
    const mail = document.getElementById('mailup').value;
    const name = document.getElementById('nameup').value;
    const id = document.getElementById('id').value;
    const pass = document.getElementById('passup').value;
    const roote = document.getElementById('rooteup')
      ? document.getElementById('rooteup').checked
      : false;

    let i, e;
    let countParents;
    let tags = [];
    let roles = [];
    let objTags;
    for (i = 0; i <= countListArray.length - 1; i++) {
      countParents = document.querySelectorAll(`[data-parent="listup-${i}"]`);
      const countParentsArray = Array.from(countParents);
      for (e = 0; e <= countParentsArray.length - 1; e++) {
        if (document.getElementById(`listup-${i}-${e}`).classList.contains('select')) {
          objTags = {};
          objTags.tag = document.getElementById(`listup-${i}-${e}`).dataset.value;
          objTags.tagCategory = document.getElementById(`listup-${i}-${e}`).dataset.category;
          tags.push(objTags);
        }
      }
    }

    rolesArray.forEach(item => {
      if (item.classList.contains('select')) {
        roles.push(item.dataset.value);
      }
    });

    const obj = {
      id: id,
      userName: mail,
      name: name,
      filterTags: tags,
      roles: roles,
      root: roote,
      password: pass
    };

    const arr = [obj];
    await this.props.actions.handleUpdateUser({ user: arr });
  };

  handleSubmitEditPass = async event => {
    const id = document.getElementById('idpass').value;
    const pass = document.getElementById('passup').value;
    const repeat_pass = document.getElementById('repeat_passup').value;
    const current_pass = document.getElementById('current_passup') ? document.getElementById('current_passup').value : '';

    const obj = {
      id: id,
      user: {
        currentPassword: current_pass,
        newPassword: pass,
        confirmedNewPassword: repeat_pass
      }
    };
    await this.props.actions.handleUpdateUserPass(obj);
  };

  handleDelete = async event => {
    const code = document.getElementById('iddelete').value;
    await this.props.actions.handleDeleteUser({ id: code });
  };

  handleActive = async event => {
    const code = document.getElementById('idactive').value;
    await this.props.actions.handleActiveUser({ id: code });
  };

  handleModalDownload = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownload ? false : true;
      this.setState({ modalDownload: reset });
    }
  };

  handleDownload = async e => {
    await this.props.actions.fetchAccountUserDownloadApi('import-users');
    this.props.actions.resetModalFileUserAccount();
    this.setState({ modalDownload: false });
  };

  handleModalUpdate = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdate ? false : true;
      this.setState({ modalUpdate: reset });
      if (!reset) {
        if (this.props.statusFile == 200) {
          document.getElementById('search').value = '';
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
        this.props.actions.resetModalFileUserAccount();
        if (this.props.statusFile == null) {
          document.getElementById('file-error').classList.add('none');
          document.getElementById('file').value = '';
          document.getElementById('file-1').innerHTML = '';
          document.getElementById('btn-upload').classList.remove('active');
        }
      }
    }
  };

  handleUploadValue = async e => {
    const fullPath = document.getElementById('file').value;
    const btnUpload = document.getElementById('btn-upload');
    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (
      (fullPath !== '' && extensionArr.toLowerCase() === 'xlsx') ||
      extensionArr.toLowerCase() === 'xls'
    ) {
      btnUpload.classList.add('active');
      document.getElementById('file-error').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error').classList.remove('none');
      } else {
        document.getElementById('file-error').classList.add('none');
      }
    }
    document.getElementById('file-1').innerHTML = fullPath;
  };

  handleUpload = async e => {
    const btnUpload = document.getElementById('btn-upload');
    if (btnUpload.classList.contains('active')) {
      await this.props.actions.fetchAccountUserUploadApi('import-users');
    }
  };

  /**
   * validates if the requested permission exists within the list of permissions that allows multiple selection of tags
   * @param {String} permission permission name
   * @returns true if the permission is inside the list, false otherwise
   */
  isMultipleTagsAllow = (permission) => {
    const listPermissionsMultipleTagsAllow = [
      ...this.listMediaPermissions,
      'ManageReadAccess',
      'ManageFullAccess',
      'FFDPVTModuleFullAccess',
      'ManageCancelAccess',
      'ReclassificationInTasksManagementAccess',
      'DeanonymizationInTasksManagementAccess',
      'BehaviorModuleFullAccess',
      'RoadWarningModuleFullAccess',
      'FatigueModuleFullAccess',
    ];

    // if the permission is inside the list, then multiple tag selection is allowed (true)
    return listPermissionsMultipleTagsAllow.includes(permission);
  }

  handleModalDownloadAssociateUsers = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalDownloadAssociateUsers ? false : true;
      this.setState({ modalDownloadAssociateUsers: reset });
      this.props.actions.resetModalFileUserAccount();
    }
  };

  handleDownloadAssociateUsers = async e => {
    await this.props.actions.fetchAccountUserDownloadApi('associate-users');

    if (this.props.statusFile === 200) {
      this.props.actions.resetModalFileUserAccount();
      this.setState({ modalDownloadAssociateUsers: false });
    }
  };

  handleModalUpdateAssociateUsers = async e => {
    if (e.target.dataset.close == 'ok') {
      const reset = this.state.modalUpdateAssociateUsers ? false : true;
      this.setState({ modalUpdateAssociateUsers: reset });
      if (!reset) {
        if (this.props.statusFile == 200) {
          document.getElementById('search').value = '';
          this.setState({ pag: 1 });
          document.getElementById('search').value = '';
          await this.props.actions.fetchAccountUserApi({ pag: 1 });
          await this.props.actions.fetchAccountUserCountApi({});
        }
        this.props.actions.resetModalFileUserAccount();
        if (this.props.statusFile == null) {
          document.getElementById('file-error-associate-users').classList.add('none');
          document.getElementById('file-associate-users').value = '';
          document.getElementById('file-1-associate-users').innerHTML = '';
          document.getElementById('btn-upload-associate-users').classList.remove('active');
        }
      }
    }
  };

  handleUploadAssociateUsers = async e => {
    const btnUpload = document.getElementById('btn-upload-associate-users');
    if (btnUpload.classList.contains('active')) {
      await this.props.actions.fetchAccountUserUploadApi('associate-users');
    }
  };

  handleUploadValueAssociateUsers = async e => {
    const fullPath = document.getElementById('file-associate-users').value;
    const btnUpload = document.getElementById('btn-upload-associate-users');
    let extensionArr = fullPath.split('.');
    extensionArr = extensionArr[extensionArr.length - 1];
    if (fullPath !== '' && (extensionArr.toLowerCase() === 'xlsx') || extensionArr.toLowerCase() === 'xls') {
      btnUpload.classList.add('active');
      document.getElementById('file-error-associate-users').classList.add('none');
    } else {
      btnUpload.classList.remove('active');
      if (fullPath !== '') {
        document.getElementById('file-error-associate-users').classList.remove('none');
      } else {
        document.getElementById('file-error-associate-users').classList.add('none');
      }
    }
    document.getElementById('file-1-associate-users').innerHTML = fullPath;
  };

  render() {
    const rol = localStoreFN().getItem('root');
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const language = this.props.language ? this.props.language.filter : '';
      return (
        <section className="main" onScroll={this.handleScroll}>
          <Header handleSearch={this.handleSearch} language={language} />
          <div className="main-container">
            {(this.props.loading || this.props.loadingRoll || this.props.optionsToCreateUserLoading) ? (
              <Loading language={this.props.language} />
            ) : this.props.status === 401 ||
              this.props.statusRoll === 401 ||
              this.props.statusCount === 401 ||
              this.props.optionsToCreateUserStatus === 401 ? (
              <Expired history={this.props.history} language={this.props.language} />
            ) : this.props.status === 200 &&
              this.props.statusRoll === 200 &&
              this.props.statusCount === 200 &&
              this.props.optionsToCreateUserStatus === 200 ? (
              <div className="main-container scroll">
                <Title language={this.props.language ? this.props.language : ''} />
                <Buttons
                  filter={this.props.filter}
                  roles={this.props.datosRoll}
                  root={rol}
                  handleModal={this.handleModal}
                  handleUserFilter={this.handleUserFilter}
                  handleTagsFilter={this.handleTagsFilter}
                  handleRolesFilter={this.handleRolesFilter}
                  language={this.props.language ? this.props.language : ''}
                  handleModalDownload={this.handleModalDownload}
                  handleModalUpdate={this.handleModalUpdate}
                  handleModalDownloadAssociateUsers={this.handleModalDownloadAssociateUsers}
                  handleModalUpdateAssociateUsers={this.handleModalUpdateAssociateUsers}
                />
                <Table
                  tags={ObjGeneral.unionArrays(obj.generalSetting.filter, ObjGeneral.getIsEnabledUbicationPVT(obj) ? [constants.ubicationPVT.toLowerCase()] : null)}
                  datos={this.props.datos}
                  handleSort={this.handleSort}
                  pag={this.state.pag}
                  count={this.props.count}
                  handleModal={this.handleModalEdit}
                  handleModalPass={this.handleModalPass}
                  handleModalDelete={this.handleModalDelete}
                  handleModalActive={this.handleModalActive}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalCreate
                  optionsToCreateUser={this.props.optionsToCreateUser}
                  root={rol}
                  filter={this.props.filter}
                  handleSelect={this.handleSelect}
                  handleSelectCheck={this.handlePermissionSelection}
                  multipleTagsAllow={this.state.multipleTagsAllow}
                  handleModal={this.handleModal}
                  handleAdmin={this.handleAdmin}
                  modal={this.state.modal}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  handleSubmit={this.handleSubmit}
                  language={this.props.language ? this.props.language : ''}
                  permissionsRef={this.permissionsRef}
                />
                <ModalEdit
                  roles={(this.props.userToEdit && this.props.userToEdit.roles) ? this.props.userToEdit.roles.map(item => ({roleName: item.valueKey}) ) : []}
                  root={rol}
                  handleChange={this.handleChange}
                  handleAdmin={this.handleAdmin}
                  filter={this.props.filter}
                  handleSelect={this.handleSelect}
                  handleSelectCheck={this.handlePermissionSelection}
                  multipleTagsAllow={this.state.multipleTagsAllow}
                  handleModal={this.handleModalEdit}
                  modal={this.state.modalEdit}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  userToEdit={this.props.userToEdit}
                  userToEditLoading={this.props.userToEditLoading}
                  userToEditStatus={this.props.userToEditStatus}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  handleSubmit={this.handleSubmitEdit}
                  language={this.props.language ? this.props.language : ''}
                  handleSetPermissionsAssociatedWithMedia = {this.setPermissionsAssociatedWithMedia}
                  permissionsRef={this.permissionsRef}
                  isRunUnitTest={this.props.isRunUnitTest}
                />
                <ModalPass
                  handleChange={this.handleChange}
                  filter={this.props.filter}
                  handleSelect={this.handleSelect}
                  handleModal={this.handleModalPass}
                  modal={this.state.modalPass}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  handleSubmit={this.handleSubmitEditPass}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDelete
                  handleSubmit={this.handleDelete}
                  handleModal={this.handleModalDelete}
                  modal={this.state.modalDelete}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalActive
                  handleSubmit={this.handleActive}
                  handleModal={this.handleModalActive}
                  modal={this.state.modalActive}
                  statusSave={this.props.statusSave}
                  loadingSave={this.props.loadingSave}
                  dataSave={this.props.dataSave}
                  config={this.state.config}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDownload
                  handleModal={this.handleModalDownload}
                  modal={this.state.modalDownload}
                  handleDownload={this.handleDownload}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalUpdate
                  handleDownload={this.handleDownload}
                  handleUpload={this.handleUpload}
                  handleUploadValue={this.handleUploadValue}
                  handleModal={this.handleModalUpdate}
                  modal={this.state.modalUpdate}
                  datos={this.props.datosFile}
                  loading={this.props.loadingFile}
                  status={this.props.statusFile}
                  language={this.props.language ? this.props.language : ''}
                />
                <ModalDownloadAssociateUsers
                  handleModal={this.handleModalDownloadAssociateUsers}
                  modal={this.state.modalDownloadAssociateUsers}
                  handleDownload={this.handleDownloadAssociateUsers}
                  language={this.props.language ? this.props.language : ''}
                  datosFile={this.props.datosFile}
                  statusFile={this.props.statusFile}
                />
                <ModalUpdateAssociateUsers
                  handleDownload={this.handleDownloadAssociateUsers}
                  handleUpload={this.handleUploadAssociateUsers}
                  handleUploadValue={this.handleUploadValueAssociateUsers}
                  handleModal={this.handleModalUpdateAssociateUsers}
                  modal={this.state.modalUpdateAssociateUsers}
                  datosFile={this.props.datosFile}
                  loadingFile={this.props.loadingFile}
                  statusFile={this.props.statusFile}
                  language={this.props.language ? this.props.language : ''}
                />

                {this.state.showConfirmChangeMultipleTagsState && (
                  <SweetAlert
                    error
                    showCancel
                    confirmBtnText={this.props.language.tasks_manager.annulConfirm.confirmButton}
                    cancelBtnText={this.props.language.tasks_manager.annulConfirm.cancelButton}
                    closeOnClickOutside={true}
                    cancelBtnCssClass="cancel-buton-test"
                    confirmBtnCssClass="confirm-button"
                    customClass={"anullSingleAlert"}
                    title={
                      <span className="modal-title">
                        <strong>
                        {' '}
                        {this.props.language.account.others.changeStateMultipleSelectQuestion}
                        </strong>
                      </span>
                    }
                    onConfirm={() => {
                      this.handleSelectCheck(null);
                      this.setState({
                        showConfirmChangeMultipleTagsState: false,
                        multipleTagsAllowChangeEvent: null
                      });
                    }}
                    onCancel={() => {
                      this.setState({
                        showConfirmChangeMultipleTagsState: false,
                        multipleTagsAllowChangeEvent: null
                      });
                    }}
                  >
                    <div className="tilte-modal-box">
                      {this.props.language.account.others.changeStateMultipleSelectWarning}
                    </div>
                  </SweetAlert>
                )}
              </div>
            ) : this.props.status === 500 ||
              this.props.statusRoll === 500 ||
              this.props.statusCount === 500 ||
              this.props.optionsToCreateUserStatus === 500 ? (
              <Message message={this.props.language.error.apiError500} />
            ) : (
              <Message message={this.props.language.error.apiError} />
            )}
          </div>
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  setting: state.reducer.dashboard.setting,

  loadingSave: state.reducer.accountUser.loadingSave,
  statusSave: state.reducer.accountUser.statusSave,
  dataSave: state.reducer.accountUser.dataSave,

  filter: ObjGeneral.unionFilters(state.reducer.tags.filter, Object.keys(state.reducer.tags.filterUbicationPVT).length > 0 ? [state.reducer.tags.filterUbicationPVT] : null),
  loadingFilter: state.reducer.tags.loading,
  statusTags: state.reducer.tags.status,

  loadingRoll: state.reducer.accountUser.loadingRoll,
  statusRoll: state.reducer.accountUser.statusRoll,
  datosRoll: state.reducer.accountUser.datosRoll,
  optionsToCreateUser: state.reducer.accountUser.optionsToCreateUser,
  optionsToCreateUserLoading: state.reducer.accountUser.optionsToCreateUserLoading,
  optionsToCreateUserStatus: state.reducer.accountUser.optionsToCreateUserStatus,

  userToEdit: state.reducer.accountUser.userToEdit,
  userToEditLoading: state.reducer.accountUser.userToEditLoading,
  userToEditStatus: state.reducer.accountUser.userToEditStatus,

  language: state.reducer.dashboard.language,
  datos: state.reducer.accountUser.datos,
  count: state.reducer.accountUser.count,
  loading: state.reducer.accountUser.loading,
  status: state.reducer.accountUser.status,
  statusCount: state.reducer.accountUser.statusCount,

  datosFile: state.reducer.accountUser.datosFile,
  loadingFile: state.reducer.accountUser.loadingFile,
  statusFile: state.reducer.accountUser.statusFile
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(accountUserActions, dispatch)
});
AccountUser.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountUser);



// WEBPACK FOOTER //
// ./source/client/containers/account_user/index.jsx